import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function UrlLinkIcon({
  height,
  stroke = IconColors.DarkGrey,
  width,
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      fill="none"
      height={height ?? 16}
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      viewBoxDimensions="0 0 16 16"
      width={width ?? 16}
    >
      <path d="M6.66656 8.66648C6.95286 9.04923 7.31813 9.36594 7.73759 9.59511C8.15705 9.82428 8.62089 9.96056 9.09766 9.9947C9.57442 10.0288 10.0529 9.96006 10.5008 9.793C10.9486 9.62594 11.3553 9.36453 11.6932 9.02648L13.6932 7.02648C14.3004 6.39781 14.6364 5.5558 14.6288 4.68181C14.6212 3.80782 14.2706 2.97178 13.6526 2.35375C13.0346 1.73573 12.1985 1.38516 11.3246 1.37757C10.4506 1.36997 9.60856 1.70595 8.97989 2.31315L7.83322 3.45315M9.33322 7.33315C9.04692 6.9504 8.68165 6.63369 8.26219 6.40452C7.84273 6.17535 7.37888 6.03907 6.90212 6.00493C6.42536 5.97078 5.94683 6.03957 5.49899 6.20663C5.05115 6.37368 4.64448 6.6351 4.30656 6.97315L2.30656 8.97315C1.69936 9.60182 1.36338 10.4438 1.37098 11.3178C1.37857 12.1918 1.72913 13.0278 2.34716 13.6459C2.96519 14.2639 3.80123 14.6145 4.67522 14.6221C5.54921 14.6297 6.39121 14.2937 7.01989 13.6865L8.15989 12.5465" />
    </SimpleIcon>
  );
}
